import { ReactNode } from 'react';
import { OneliveLayoutProvider, useOneliveLayout } from './OneliveLayoutContext';

interface OneliveShellProps {
  children: ReactNode;
}

function OneliveShellInner({ children }: OneliveShellProps) {
  const { sidebarCollapsed } = useOneliveLayout();

  return (
    <div className={`onelive-shell${sidebarCollapsed ? ' is-sidebar-collapsed' : ''}`}>
      {children}
    </div>
  );
}

export default function OneliveShell({ children }: OneliveShellProps) {
  return (
    <OneliveLayoutProvider>
      <OneliveShellInner>{children}</OneliveShellInner>
    </OneliveLayoutProvider>
  );
}
